export default "__VITE_ASSET__BQoAhLsS__"